var _defs, _path, _line, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeautyEarthandPlanetElements06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1e2220;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.42px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.43,36.43c-8.07,9.55-18.68,28.54,1.04,48.46,3.27,3.3,8.65,3.13,11.67-.4,7.22-8.44,16.64-25.77-.42-47.76-3.08-3.97-9.05-4.14-12.29-.3Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.8,
    y1: 57.42,
    x2: 88.8,
    y2: 132.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.84,121.02s1.32-26.54,42.07-26.54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.79,123.1s.56-26.81-40.2-26.81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.72,145.18c.19-7.45-4.78-12.33-11.43-12.33-7.23,0-10.7,5.34-10.94,11.22-.3-6.83-5.1-11.22-11.42-11.22-7.23,0-10.7,5.34-10.94,11.22-.3-6.83-5.1-11.22-11.42-11.22-7.23,0-10.7,5.34-10.94,11.22-.3-6.83-5.1-11.22-11.42-11.22-7.23,0-10.7,5.34-10.94,11.22-.3-6.83-5.1-11.22-11.42-11.22-7.68,0-11.12,6.02-10.95,12.33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.05,92.39c-9.11-8.56-27.52-20.15-48.45-1.51-3.47,3.09-3.58,8.47-.21,11.67,8.05,7.65,24.86,17.97,47.71,2.09,4.13-2.87,4.61-8.82.94-12.26Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.23,85.73c10.65-6.54,31.02-14.17,47.75,8.33,2.77,3.73,1.79,9.02-2.16,11.47-9.43,5.86-27.98,12.57-47.15-7.6-3.46-3.64-2.73-9.57,1.56-12.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeautyEarthandPlanetElements06);
export default __webpack_public_path__ + "static/media/Beauty, Earth and Planet Elements-06.5392dfa823795d3ad75ca6517851d5d6.svg";
export { ForwardRef as ReactComponent };